import { UseQueryOptions, useQuery } from '@tanstack/react-query';

import { getWorkspaceSettings } from '../../../api/workspaces/settings/getWorkspaceSettings';
import { WorkspaceSettings } from '../../../api/workspaces/types';
import { workspaceKeys } from './workspaceQueryKeyFactory';

interface UseGetWorkspaceSettingsParams<TSelected = WorkspaceSettings> {
  workspaceId: string;
  enabled?: boolean;
  select?: UseQueryOptions<
    WorkspaceSettings,
    unknown,
    TSelected,
    ReturnType<typeof workspaceKeys.settings>
  >['select'];
}

export function useGetWorkspaceSettings<TSelected = WorkspaceSettings>({
  workspaceId,
  enabled = true,
  select,
}: UseGetWorkspaceSettingsParams<TSelected>) {
  return useQuery({
    queryKey: workspaceKeys.settings(workspaceId),
    queryFn: () => getWorkspaceSettings(workspaceId),
    enabled: enabled && !!workspaceId,
    select,
    staleTime: 30_000,
  });
}
